import { render, staticRenderFns } from "./BabyView.vue?vue&type=template&id=752c877d"
import script from "./BabyView.vue?vue&type=script&lang=js"
export * from "./BabyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports